import text_logo from "../../assets/images/text_logo.svg";
import contactus_bg from "../../assets/icons/contactus-bg.png";
import { useEffect } from "react";
import { useIntercom } from "react-use-intercom";
import { Link } from "react-router-dom";
import { Stack } from "@altimateai/lego";

const ContactUsIntercom = () => {
  const { show } = useIntercom();

  useEffect(() => {
    const config = { attributes: false, childList: true, subtree: false };

    const callback = (mutations: MutationRecord[], obs: MutationObserver) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node instanceof HTMLElement) {
              if (node.id === "intercom-frame") {
                obs.disconnect();
                show();
              }
            }
          });
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, [show]);

  return (
    <Stack direction="column" className="al-h-screen">
      <header className="al-p-4">
        <div>
          <Link to="/">
            <img src={text_logo} alt="Altimate AI" />
          </Link>
        </div>
      </header>
      <div
        className="al-flex-1 al-bg-cover al-bg-no-repeat al-bg-center"
        style={{ backgroundImage: `url(${contactus_bg})` }}
      />
    </Stack>
  );
};

export { ContactUsIntercom };
